import initLabels from '~/init_labels';

document.addEventListener('DOMContentLoaded', initLabels);
